import { render, staticRenderFns } from "./SfSticky.vue?vue&type=template&id=29b751e1&"
import script from "./SfSticky.vue?vue&type=script&lang=js&"
export * from "./SfSticky.vue?vue&type=script&lang=js&"
import style0 from "./SfSticky.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports